export const ADDITIONAL_INFO_ICON_SIZE = 14
